import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  Tabs,
  Tab,
  Box,
  TextField,
  Typography,
} from "@mui/material";
import EditText from "../../components/editText";
import AddFaq from "../../Modals/addFaq";
import DeleteConfirmModal from "../../Modals/deleteConfirmModal";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { useFormik } from "formik";
import useAuth from "../../hooks/useAuth";
import { CommonBody } from "../../types/General";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import * as Yup from "yup";
import Loader from "../../constants/Loader";
import { showError, showToast } from "../../constants/toasts";
import {
  useLazyGetCmsQuery,
  useUpdateCmsMutation,
  useLazyGetFAQQuery,
  useDeleteFaqMutation,
} from "../../services/cms";
import Pagination from "../../components/Panigation";
import IfCan from "../../components/IfCan";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// Helper function to truncate text
const truncateText = (text: string, maxLength: number) => {
  if (!text) return "-";
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + "...";
};

const ManageCms = () => {
  const navigate = useNavigate();
  const user = useAuth();

  

  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // CMS content states
  const [privacyPolicy, setPrivacyPolicy] = useState<string>("");
  const [aboutUs, setAboutUs] = useState<string>("");
  const [termsAndConditions, setTermsAndConditions] = useState<string>("");
  const [phoneDisplay, setPhoneDisplay] = useState("");
  const [phoneCode, setPhoneCode] = useState("+91");
  const [cmsId, setCmsId] = useState<number | null>(null);

  const [legal3, setLegal3] = useState<string>("");
  const [legal4, setLegal4] = useState<string>("");

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [openModal, setOpenModal] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedFaqId, setSelectedFaqId] = useState<string>("");
  const [editFaqData, setEditFaqData] = useState<any>(null);
  const [isEditFaq, setIsEditFaq] = useState(false);
  const [page, setPage] = useState(1);

  const handleCloseModal = () => {
    setOpenModal(false);
    setEditFaqData(null);
    setIsEditFaq(false);
  };
  const [error, setError] = useState(false);
  const [isEdit, setIsEdit] = useState(true);

  // API hooks
  const [updateCMS] = useUpdateCmsMutation();
  const [getCms] = useLazyGetCmsQuery();
  const [getFAQ] = useLazyGetFAQQuery();
  const [deleteFAQ] = useDeleteFaqMutation();

  // FAQ states
  const [faqList, setFaqList] = useState<any[]>([]);
  const [faqStart, setFaqStart] = useState(1);
  const [faqLength] = useState(10);
  const [faqTotalCount, setFaqTotalCount] = useState(0);
  const [faqSearchTerm, setFaqSearchTerm] = useState("");
  const [faqLoading, setFaqLoading] = useState(false);
  const totalPages = Math.ceil(faqTotalCount / 10);
  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };

  // Formik configuration
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      phone: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Enter a valid email address"
        ),
      phone: Yup.string()
        .required("Phone number is required")
        .min(6, "Phone number must be at least 6 characters")
        .max(16, "Phone number must be at least 16 characters"),
    }),
    onSubmit: async (_values, { setSubmitting }) => {
      try {
        await updateCmsContact();
      } finally {
        setSubmitting(false);
      }
    },
  });

  // Get CMS data
  const getCmsData = async () => {
    setIsLoading(true);
    try {
      const response = await getCms({}).unwrap();
      if (response.status == 200) {
        setCmsId(response?.data?.id || null);
        setPrivacyPolicy(response?.data?.privacy || "");
        setTermsAndConditions(response?.data?.terms_and_conditions || "");
        setAboutUs(response?.data?.about_us || "");
        formik.setFieldValue("email", response.data?.email || "");
        formik.setFieldValue("phone", response?.data?.phone_no || "");
        setPhoneCode(response?.data?.country_code || "+91");
        setPhoneDisplay(
          (response?.data?.country_code || "+91") +
            (response?.data?.phone_no || "")
        );

        // Set legacy states for backward compatibility
        setLegal3(response?.data?.terms_and_conditions || "");
        setLegal4(response?.data?.privacy || "");
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

 
  const handleChangePhone = (phone: any, country: any) => {
    const newDialCode = country?.dialCode || "";

   
    if (newDialCode !== phoneCode) {
      formik.setFieldValue("phone", "");
      setPhoneDisplay("");
      setPhoneCode(newDialCode);
      return;
    }

    
    const numberWithoutDialCode = (phone || "").replace(newDialCode, "");
    formik.setFieldValue("phone", numberWithoutDialCode);
    setPhoneDisplay(newDialCode + numberWithoutDialCode);
  };

  // Build CMS body for API calls
  const buildCmsBody = () => ({
    id: cmsId,
    email: formik.values.email,
    country_code: phoneCode,
    phone_no: formik.values.phone,
    terms_and_conditions: termsAndConditions,
    privacy: privacyPolicy,
    about_us: aboutUs,
  });

  // Update functions for different sections
  const updateCmsContact = async () => {
    try {
      const response = await updateCMS(buildCmsBody()).unwrap();
      if (response.status === 200) {
        showToast("Contact details updated successfully");
      }
    } catch (error: any) {
      showError(error?.data?.message);
    }
  };

  const updateCmsPrivacy = async () => {
    try {
      const response = await updateCMS(buildCmsBody()).unwrap();
      if (response.status === 200) {
        showToast("Privacy Policy updated successfully");
      }
    } catch (error: any) {
      showError(error?.data?.message);
    }
  };

  const updateCmsTerms = async () => {
    try {
      const response = await updateCMS(buildCmsBody()).unwrap();
      if (response.status === 200) {
        showToast("Terms and Conditions updated successfully");
      }
    } catch (error: any) {
      showError(error?.data?.message);
    }
  };

  const updateCmsAbout = async () => {
    try {
      const response = await updateCMS(buildCmsBody()).unwrap();
      if (response.status === 200) {
        showToast("About Us updated successfully");
      }
    } catch (error: any) {
      showError(error?.data?.message);
    }
  };

  // FAQ functions
  const getFaqList = async () => {
    setFaqLoading(true);
    try {
      const response = await getFAQ({
        search: faqSearchTerm,
        start: page,
        length: faqLength,
      }).unwrap();
      if (response?.status === 200) {
        // Handle direct array response
        if (Array.isArray(response?.data)) {
          setFaqList(response?.data || []);
          setFaqTotalCount(response?.data?.recordsTotal || 0);
        } else {
          // Handle structured response with list and totalCount
          setFaqList(response?.data?.list || []);
          setFaqTotalCount(response?.data?.recordsTotal || 0);
        }
      } else {
        setFaqList([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "Failed to fetch FAQs");
    }
    setFaqLoading(false);
  };

  const handleDeleteFaq = async () => {
    try {
      await deleteFAQ({ id: selectedFaqId }).unwrap();
      showToast("FAQ deleted successfully");
      getFaqList();
    } catch (error: any) {
      showError(error?.data?.message || "Failed to delete FAQ");
    }
    setDeleteModalOpen(false);
  };

  const handleEditFaq = (faq: any) => {
    setEditFaqData(faq);
    setIsEditFaq(true);
    setOpenModal(true);
  };

  const handleAddFaq = () => {
    setEditFaqData(null);
    setIsEditFaq(false);
    setOpenModal(true);
  };

  // Load data on component mount
  useEffect(() => {
    getCmsData();
  }, []);

  // Reset start when search changes
  useEffect(() => {
    if (valueTabs === 4) {
      setFaqStart(1);
    }
  }, [faqSearchTerm, valueTabs]);

  // Load FAQ data when tab changes or search/start changes
  useEffect(() => {
    if (valueTabs === 4) {
      getFaqList();
    }
  }, [valueTabs, faqStart, faqSearchTerm]);

  

  return (
    <>
      <Loader isLoad={isLoading} />

      <div className="main_title">
        <h1>Manage CMS</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          CMS
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Contact Support" {...a11yProps(0)} />
              <Tab label="Terms and Conditions" {...a11yProps(1)} />
              <Tab label="Privacy Policy" {...a11yProps(2)} />
              <Tab label="About Us" {...a11yProps(3)} />
              <Tab label="FAQ's" {...a11yProps(4)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <form
            className="form"
            onSubmit={formik.handleSubmit}
          >
            <div className="gap_p">
              <div className="control_group w_50">
                <label>Email Address</label>
                <TextField
                  variant="outlined"
                  placeholder="Enter here"
                  fullWidth
                  hiddenLabel
                  type="email"
                  name="email"
                  value={formik.values.email}
                  onChange={(e) => {
                    if (e.target.value == " ") return;
                    if (e.target.value.length <= 50) formik.handleChange(e);
                    else showError("Email can't exceed 50 characters");
                  }}
                  onBlur={formik.handleBlur}
                  error={Boolean((formik.touched.email || formik.submitCount > 0) && formik.errors.email)}
                  helperText={(formik.touched.email || formik.submitCount > 0) && formik.errors.email}
                />
              </div>
              <div className="control_group w_50">
                <label>Phone Number</label>
                <PhoneInput
                  country={"us"}
                  placeholder="0 (000) 000-000"
                  enableSearch={true}
                  value={phoneDisplay}
                  onChange={handleChangePhone}
                  onBlur={() => formik.setFieldTouched("phone", true)}
                  inputStyle={{ width: "100%" }}
                />
                {(formik.touched.phone || formik.submitCount > 0) && formik.errors.phone ? (
                  <h6 className="err_msg">
                    {formik.errors.phone}
                  </h6>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="form_btn">
              <IfCan module="Manage CMS" action="add_edit">
                {isEdit && (
                  <Button
                    className="btn btn_primary"
                    type="submit"
                    disabled={formik.isSubmitting}
                  >
                    Save
                  </Button>
                )}
              </IfCan>
            </div>
          </form>
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={1}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              updateCmsTerms();
            }}
          >
            <EditText
              content={termsAndConditions}
              setContent={setTermsAndConditions}
            />
            <div className="form_btn">
              <IfCan module="Manage CMS" action="add_edit">
                {isEdit && (
                  <Button className="btn btn_primary" type="submit">
                    Save
                  </Button>
                )}
              </IfCan>
            </div>
          </form>
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={2}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              updateCmsPrivacy();
            }}
          >
            <EditText content={privacyPolicy} setContent={setPrivacyPolicy} />
            <div className="form_btn">
              <IfCan module="Manage CMS" action="add_edit">
                {isEdit && (
                  <Button className="btn btn_primary" type="submit">
                    Save
                  </Button>
                )}
              </IfCan>
            </div>
          </form>
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={3}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              updateCmsAbout();
            }}
          >
            <EditText content={aboutUs} setContent={setAboutUs} />
            <div className="form_btn">
              <IfCan module="Manage CMS" action="add_edit">
                {isEdit && (
                  <Button className="btn btn_primary" type="submit">
                    Save
                  </Button>
                )}
              </IfCan>
            </div>
          </form>
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={4}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={faqSearchTerm}
                setDebouncedSearchTerm={setFaqSearchTerm}
                placeholder="Search FAQs..."
              />
            </div>
            <IfCan module="Manage CMS" action="add_edit">
              <div className="right_s">
                <Button className="btn btn_primary" onClick={handleAddFaq}>
                  Add FAQ
                </Button>
              </div>
            </IfCan>
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Sr.no</TableCell>
                  <TableCell>Question</TableCell>
                  <TableCell>Answer</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {faqLoading ? (
                  <TableRow>
                    <TableCell colSpan={4} style={{ textAlign: "center" }}>
                      Loading...
                    </TableCell>
                  </TableRow>
                ) : faqList.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={4} style={{ textAlign: "center" }}>
                      No FAQs found
                    </TableCell>
                  </TableRow>
                ) : (
                  faqList.map((faq: any, index: number) => (
                    <TableRow hover key={faq.id || faq._id}>
                      <TableCell>
                        {(page - 1) * faqLength + index + 1}
                      </TableCell>
                      <TableCell>
                        <div title={faq.question}>
                          {truncateText(faq.question, 50)}
                        </div>
                      </TableCell>
                      <TableCell className="max_c2">
                        <div title={faq.answer}>
                          {truncateText(faq.answer, 80)}
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className="table_actions v2">
                          <IfCan module="Manage CMS" action="add_edit">
                            <IconButton onClick={() => handleEditFaq(faq)}>
                              <img src="/static/images/edit2_icon.svg" alt="" />
                            </IconButton>
                          </IfCan>
                          <IfCan module="Manage CMS" action="delete">
                            <IconButton
                              onClick={() => {
                                setSelectedFaqId(faq.id || faq._id);
                                setDeleteModalOpen(true);
                              }}
                            >
                              <img src="/static/images/trash2_icon.svg" alt="" />
                            </IconButton>
                          </IfCan>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
        {/* <Pagination
          module={faqList}
          page={page}
          onPageChange={onPageChange}
          totalPages={totalPages}
          totalCount={faqTotalCount}
          setPage={setPage}
        /> */}
      </div>

      <IfCan module="Manage CMS" action="add_edit">
        <AddFaq
          open={openModal}
          onClose={handleCloseModal}
          setOpen={setOpenModal}
          editData={editFaqData}
          isEdit={isEditFaq}
          onSuccess={getFaqList}
        />
      </IfCan>

      <IfCan module="Manage CMS" action="delete">
        <DeleteConfirmModal
          open={deleteModalOpen}
          setOpen={setDeleteModalOpen}
          handleDelete={handleDeleteFaq}
          title="Are you sure you want to delete this FAQ?"
          message="This action cannot be undone."
        />
      </IfCan>
    </>
  );
};

export default ManageCms;
